"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4463],{

/***/ 454463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _components_Common_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(672651);
/* harmony import */ var node_modules_mui_icons_material_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(386878);
/* harmony import */ var src_utils_getThemeColor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(270758);






var WishlistItemDeletionAlert = function(param) {
    var showDeleteConfirmationModal = param.showDeleteConfirmationModal, setShowDeleteConfirmationModal = param.setShowDeleteConfirmationModal;
    var themeColor = (0,src_utils_getThemeColor__WEBPACK_IMPORTED_MODULE_2__/* .getThemeColor */ .p)() || "#000000";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        visible: showDeleteConfirmationModal === null || showDeleteConfirmationModal === void 0 ? void 0 : showDeleteConfirmationModal.open,
        className: "bottom-modal mw6-ns",
        animation: "slideUp",
        height: "auto",
        customStyles: {
            maxWidth: "450px"
        },
        onClose: function() {
            return setShowDeleteConfirmationModal(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, prev), {
                    open: false
                });
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-gap-[18px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "tw-text-[18px] tw-font-inter tw-font-bold",
                            children: "Remove Item"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(node_modules_mui_icons_material_index__WEBPACK_IMPORTED_MODULE_5__/* .Close */ .x8P, {
                                fontSize: "small",
                                style: {
                                    cursor: "pointer"
                                },
                                onClick: function() {
                                    return setShowDeleteConfirmationModal(function(prev) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, prev), {
                                            open: false
                                        });
                                    });
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "tw-m-0 tw-text-sm tw-text-[#606060]",
                    children: "Are you sure you want to remove this item from your wishlist?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-justify-end tw-gap-[16px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: function() {
                                return showDeleteConfirmationModal === null || showDeleteConfirmationModal === void 0 ? void 0 : showDeleteConfirmationModal.confirmCallback();
                            },
                            className: "tw-cursor-pointer tw-rounded-lg tw-border tw-border-solid tw-border-[#FF0000] tw-bg-transparent tw-p-[12px] tw-text-[#FF0000]",
                            children: "Remove Item"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: function() {
                                return setShowDeleteConfirmationModal(function(prev) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            className: "tw-cursor-pointer tw-rounded-lg tw-border tw-border-solid !tw-border-[#E3E3E3] tw-bg-transparent tw-p-[12px]",
                            style: {
                                color: themeColor
                            },
                            children: "Cancel"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (WishlistItemDeletionAlert);


/***/ })

}]);